import * as React from 'react';
import { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'

interface IFileDropZoneProps
{
	/** Признак отключения */
	Disabled: boolean,

	/** Текст внутри кнопки */
	ButtonText: string,

	/** Текст рядом с кнопкой */
	DescriptionText: string,

	/** Текст рядом с кнопкой мелким шрифтом */
	TipText: any,

	/** Разрешенные для дропания типы файлов */
	Accept?: string,

	/**
	 *  Функция, выполняемая после кидания файлов по Drag'n'Drop 
	 *  @param acceptedFiles список файлов, принятых дроп-зоной
	 */
	OnDropAction: (acceptedFiles:File[]) => void,

	/** Признак ошибки */
	IsError?: boolean,

	/** CSS Класс для текста рядом с кнопкой мелким шрифтом */
	TipClass?: string
}

export const FileDropZone: React.FC<IFileDropZoneProps> =
	(
		// входные параметры компонента
		{ Disabled, ButtonText, DescriptionText, TipText, Accept, OnDropAction, IsError, TipClass="muted"}: IFileDropZoneProps
	) =>
	{
		// заворачиваем входную функцию в CallBack
		const onDrop = useCallback(acceptedFiles => OnDropAction(acceptedFiles), [OnDropAction]);

		const
			{
				getRootProps,	// функция, куда можно передавать атрибуты главного DIV-а
				getInputProps,	// функция, куда можно передавать атрибуты главного INPUT-а
				open			// функция открытия диалога выбора файлов
			} = useDropzone(
				{
					onDrop,		//callback обработчика брошенных (или выбранных) файлов
					accept: Accept,
					noClick: true,		// Disable click behavior
					noKeyboard: true,	// Disable keydown behavior
					disabled: Disabled
				})

		return (
			<div {...getRootProps()} className={"main-file-upload" + (IsError ? " error" : "")}>
				<div
					className="file-upload-area"
					onDragOver={(e: React.DragEvent<HTMLDivElement>) => { e.currentTarget.className = "file-upload-area drag"; }}
					onDragLeave={(e: React.DragEvent<HTMLDivElement>) => { e.currentTarget.className = "file-upload-area"; }}
				>
					<div className="d-flex align-items-center">
						<input {...getInputProps()} />
						<button
							type="button"
							onClick={open}
							disabled={Disabled}
							className="btn btn-success mb-0 mr-md-4"
						>
							{ButtonText}
						</button>
						<div className="upload-text">
							<p className="mb-1 hidden-xs hidden-sm">{DescriptionText}</p>
							<p className={"mb-0 f-14 " + TipClass}>{TipText}</p>
						</div>
					</div>
				</div>
			</div>
		)
	}
